// eslint-disable
import UsersTable from './components/UsersTable';

export const Users = () => {
  return (
    <div className="w-full h-full">
      <UsersTable />
    </div>
  );
};
